const campaignTriggerTypeLabels = Object.freeze({
  scheduled: 'AnalyticsCampaignsPage_Table_Type_Scheduled',
  repeating: 'AnalyticsCampaignsPage_Table_Type_Repeating',
  event: 'AnalyticsCampaignsPage_Table_Type_Event',
  accumulation: 'AnalyticsCampaignsPage_Table_Type_Accumulation',
  inapp: 'AnalyticsCampaignsPage_Table_Type_Inapp',
  location: 'AnalyticsCampaignsPage_Table_Type_Location',
  api: 'AnalyticsCampaignsPage_Table_Type_Api',
  optimove: 'AnalyticsCampaignsPage_Table_Type_Optimove',
  salesforce: 'AnalyticsCampaignsPage_Table_Type_Salesforce'
})

export { campaignTriggerTypeLabels }



// WEBPACK FOOTER //
// ./src/modules/analytics/enum/CampaignTypeLabels.js